import axios from 'axios';
import qs from 'qs';

const BASE_URL = process.env.API || 'https://dev.api.crypto-id.vareger.com';
const SCANNER_URL = 'http://127.0.0.1:9003';
const BTC_INFO = 'https://api.blockcypher.com/v1/btc/main';

const getTransactionBTC = (txHash) => {
    const headers = {};

    return (
        axios({
            headers,
            method: 'get',
            url: `${BTC_INFO}/txs/${txHash}`,
        })
    );
};

const getBalanceBTC = (address) => {
    const headers = {};
    return (
        axios({
            headers,
            method: 'get',
            url: `${BTC_INFO}/addrs/${address}/balance`,
        })
    );
};

const get = (path, token, scanner) => {

    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };

    if (scanner) {
        return (
            axios({
                headers,
                method: 'get',
                url: `${SCANNER_URL}/${path}`,
            })
        );
    }

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    return (
        axios({
            headers,
            method: 'get',
            url: `${BASE_URL}/${path}`,
        })
    );
}

const post = (path, body, token) => {
    const headers = {
        'Content-Type': 'application/json',
    };

    if (token) {
        headers['Authorization'] = `Bearer ${token}`;
    }

    return (
        axios({
            headers,
            method: 'post',
            url: `${BASE_URL}/${path}`,
            data: body ? JSON.stringify(body) : undefined,
        })
    );
}

const postFormData = (path, body, token) => {
    return axios({
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `${token ? `Bearer ${token}` : 'Basic dHJ1c3RlZGNsaWVudGlkOmpIcm82OUFtbFZ6b2FrUThiOWFZZ0pkNw=='}`,
        },
        method: 'post',
        url: `${BASE_URL}/${path}`,
        data: qs.stringify(body),
    })
};

const postFormDataSimple = (path, body, token) => {
    return axios({
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `${token ? `Bearer ${token}` : 'Basic dHJ1c3RlZGNsaWVudGlkOmpIcm82OUFtbFZ6b2FrUThiOWFZZ0pkNw=='}`,
        },
        method: 'post',
        url: `${BASE_URL}/${path}`,
        data: body,
    })
};

const put = (path, body, token) => (
    axios({
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        method: 'put',
        url: `${BASE_URL}/${path}`,
        data: body ? JSON.stringify(body) : undefined,
    })
);

const deleteReq = (path, token) => (
    axios({
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        method: 'delete',
        url: `${BASE_URL}/${path}`,
    })
)

export const Api = {
    get,
    post,
    put,
    deleteReq,
    postFormData,
    getTransactionBTC,
    getBalanceBTC,
    postFormDataSimple
};



// WEBPACK FOOTER //
// ./src/api.js